/**
 * Client-side hooks - runs before any rendering
 *
 * This is the best place to initialize MSW because it runs
 * before any components render or make API calls.
 */
import { enableMocking } from '$lib/mocks/index';
import { registerAppCookieClientStrategy } from '$lib/i18n/app-cookie-strategy';
import posthog from 'posthog-js';
import type { HandleClientError } from '@sveltejs/kit';
import { captureClientError } from '$lib/services/telemetry/errorEnvelope';
import { installConsoleBoundary } from '$lib/services/telemetry/consoleBoundary';

installConsoleBoundary();

// SAM-836: must run before the first getLocale() call (first render), so the
// app area resolves its language from the preference cookie, not the URL.
registerAppCookieClientStrategy();

// Initialize MSW immediately on client
// This prevents race conditions where components make API calls
// before MSW is ready to intercept them
await enableMocking();

// SAM-1031: raw client exceptions are never sent to telemetry;
// message and stack of an error that routinely quotes the failing payload —
// a journal note, an email, or an echoed Authorization header. The failure now
// travels as an allowlisted envelope, and only once the user has opted into
// analytics (SAM-194).
export const handleError: HandleClientError = ({ error, event, status }) => {
	captureClientError(posthog, { status, routeId: event.route.id, error });
};
